var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "betslip-bet-wrapper" },
    _vm._l(_vm.ticket.bets, function (bet, key) {
      return _c(
        "div",
        {
          key: key,
          staticClass: "betslip-bet",
          class: [
            {
              active: key === _vm.selectedIndex && _vm.editMode && _vm.editable,
            },
            { disabled: _vm.bettingLocked },
          ],
          on: {
            click: function ($event) {
              return _vm.selectBet(bet, key)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "bet-title" },
            _vm._l(bet.title, function (value, index) {
              return _c(
                "span",
                { key: index, staticClass: "bet-title-outcome" },
                [_vm._v(" " + _vm._s(_vm._f("translate")(value.title)) + " ")]
              )
            }),
            0
          ),
          _c("div", { staticClass: "bet-subtitle" }, [
            _vm._v(" " + _vm._s(_vm._f("translate")(bet.subtitle)) + " "),
          ]),
          _c("div", { staticClass: "bet-footer" }, [
            _c("div", { staticClass: "round-info" }, [
              _c("div", { staticClass: "pull-left" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(
                    " " + _vm._s(_vm._f("translate")("general_round")) + " "
                  ),
                ]),
                _c("div", { staticClass: "value" }, [
                  _vm._v(" " + _vm._s(_vm.roundInfo) + " "),
                ]),
              ]),
              _c("div", { staticClass: "pull-right" }, [
                _c("div", { staticClass: "odd-info" }, [
                  _vm._v(" " + _vm._s(_vm.getOdd(bet)) + " "),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "stake-info" }, [
              _c("div", [
                _c("div", { staticClass: "label" }, [
                  _vm._v(
                    " " + _vm._s(_vm._f("translate")("general_stake")) + " "
                  ),
                ]),
                _c(
                  "div",
                  { ref: "myTable", refInFor: true, staticClass: "value" },
                  [_vm._v(" " + _vm._s(bet.payment.toFixed(2)) + " ")]
                ),
              ]),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "remove-bet",
              on: {
                click: function ($event) {
                  return _vm.removeFromBetslip(bet, $event)
                },
              },
            },
            [_c("i", { staticClass: "icon icon-close" })]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }